/* §6.4 — solidify at 96, return at 72. 24px hysteresis. No libraries. */
(function(){
  var DOWN=96, UP=72, solid=false, ticking=false;
  function apply(){
    var y=window.scrollY;
    if(!solid && y>DOWN){ solid=true; document.body.classList.add('wx-solid'); }
    else if(solid && y<UP){ solid=false; document.body.classList.remove('wx-solid'); }
    ticking=false;
  }
  function onScroll(){ if(!ticking){ requestAnimationFrame(apply); ticking=true; } }
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('scroll', onScroll, {passive:true});
  document.addEventListener('click', function(e){
    var t=e.target.closest('.wx-drop__trigger');
    document.querySelectorAll('[data-wx-drop]').forEach(function(d){
      var open = t && d.contains(t) && !d.classList.contains('is-open');
      d.classList.toggle('is-open', !!open);
      var b=d.querySelector('.wx-drop__trigger'); if(b) b.setAttribute('aria-expanded', open?'true':'false');
    });
  });
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape') document.querySelectorAll('[data-wx-drop].is-open').forEach(function(d){d.classList.remove('is-open');});
  });
})();
/* §6.5 mobile panel */
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-wx-burger]');
    if(b){ var open=!document.body.classList.contains('wx-menu-open');
      document.body.classList.toggle('wx-menu-open',open);
      b.setAttribute('aria-expanded',open?'true':'false');
      b.textContent = open ? 'Close' : 'Menu'; }
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&document.body.classList.contains('wx-menu-open')){
      document.body.classList.remove('wx-menu-open');
      var b=document.querySelector('[data-wx-burger]');
      if(b){b.setAttribute('aria-expanded','false');b.textContent='Menu';}
    }});
})();
